import React, { useEffect, useState } from 'react'
import Proptypes from 'prop-types'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { Modal, Button, Form } from 'semantic-ui-react'
import Swal from 'sweetalert2'
import { primaryColor } from '../../../../constants'
import IntelMsg from '../../../ItelMsg/index'
import { UpdateAssetLabel } from '../../../../services/asset'

const specialChar = /^[A-Za-z0-9ء-ي ]+$/

const formValidator = {
  label: yup
    .string()
    .trim()
    .required('Name Is Required')
    .matches(specialChar, 'Name has invalid characters'),
}

const EditHierarchyModal = (props) => {
  console.log('level: ', props.level)
  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(yup.object().shape(formValidator)),
  })
  const [open, setOpen] = useState(false)
  useEffect(() => {
    setOpen(props.openEdit)
  }, [props.openEdit])

  useEffect(() => {
    props.getEditModalState(open)
  }, [open])

  const onSubmit = async (data) => {
    const queryParams = {
      customerId: props.level.customerId,
      label: data.label,
    }
    Swal.showLoading()
    const res = await UpdateAssetLabel(queryParams, props.level.id)
    if (res.success) {
      await Swal.fire('Label Updated Successfully', '', 'success')
      setOpen(false)
    } else {
      console.log('error', res.msg)
      Swal.fire(res.msg || 'Error Updating label', '', 'error')
    }
  }
  return (
    <>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        style={{ width: '450px' }}
      >
        <Modal.Header style={{ backgroundColor: '#303D54', color: '#FFF' }}>
          Edit {props.level.label || props.level.name}
        </Modal.Header>
        <Modal.Content>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group>
              <Form.Field required>
                <strong>Label</strong>
                <input
                  placeholder="Enter new label"
                  ref={register}
                  name="label"
                />
                <small style={{ color: 'red' }}>
                  <IntelMsg id={['**']} />
                </small>
                {errors.label && (
                  <p style={{ color: 'red' }}>{errors.label.message}</p>
                )}
              </Form.Field>
            </Form.Group>
            <Button type="submit">Submit</Button>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            style={{ backgroundColor: primaryColor, color: 'white' }}
            onClick={() => setOpen(false)}
          >
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  )
}

EditHierarchyModal.propTypes = {
  openEdit: Proptypes.bool,
  getEditModalState: Proptypes.func,
  level: Proptypes.object,
}

export default EditHierarchyModal
